var _a;
import { StoresWidgetID, VIEWER_SCRIPT_DSN } from '../constants';
export var CART_ICON_DSN = 'https://31e500c94d2042ff81a38a0e4a2873b7@sentry.io/1252955';
export var GALLERY_PAGE_DSN = 'https://337a342c302c4c0e8c26e425e74da4c1@sentry.io/1363752';
export var SLIDER_GALLERY_DSN = 'https://c4847d204c6e4c1aa7f9ff220369cee2@sentry.io/1388877';
export var PRODUCT_PAGE_DSN = 'https://5605bf8f38c54260af44e1d7bc2450bd@sentry.io/1362236';
export var PRODUCT_WIDGET_DSN = 'https://04ac210d4a934172b7aead660647e5a0@sentry.io/1411933';
export var THANK_YOU_PAGE_DSN = VIEWER_SCRIPT_DSN;
export var sentryConfPerController = (_a = {},
    _a[StoresWidgetID.CART_ICON] = CART_ICON_DSN,
    _a[StoresWidgetID.PRODUCT_PAGE] = PRODUCT_PAGE_DSN,
    _a[StoresWidgetID.GALLERY_PAGE] = GALLERY_PAGE_DSN,
    _a[StoresWidgetID.GRID_GALLERY] = GALLERY_PAGE_DSN,
    _a[StoresWidgetID.SLIDER_GALLERY] = SLIDER_GALLERY_DSN,
    _a[StoresWidgetID.PRODUCT_WIDGET] = PRODUCT_WIDGET_DSN,
    _a[StoresWidgetID.THANK_YOU_PAGE] = THANK_YOU_PAGE_DSN,
    _a);
//# sourceMappingURL=sentryConf.js.map